<template>
  <v-card v-if="model.id" class="elevation-2">
    <v-card-title class="text-h5">
      <h2 class="font-weight-bold text--primary">Horario por dia de la semana</h2>
    </v-card-title>
    <v-card-subtitle>
      <label class="subtitle-1 font-weight-bold black--text">
        {{model.adscripcion.empleado.cve_empleado}} - {{model.adscripcion.empleado.NombreCompleto}}
      </label>
    </v-card-subtitle>
    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <v-btn color="success" small dark class="mr-1" @click="successTableAction({ action: 'newHorarioData' })">
            <v-icon left>mdi-plus</v-icon>Nuevo
          </v-btn>
        </v-col>
        <v-col cols="4" v-for="(dia, index) in semana" :key="index">
          <v-card class="mx-auto">
            <v-card-title>{{dia.name}}</v-card-title>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12">
                  <v-list v-if="model.configuraciones.dias">
                    <v-list-item v-for="(hora, index) in model.configuraciones.dias[dia.nameid]" :key="index">
                      <v-row align="center">
                        <v-btn color="red darken-3" class="mx-2" @click="successTableAction({ action: 'deleteHorarioData', body: { hora, dia } })" outlined icon>
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <v-icon class="mx-1">mdi-credit-card-clock-outline</v-icon>
                        <span class="subheading mx-2">Entrada: {{hora.he}}</span>
                        <span class="subheading mx-2">Salida: {{hora.hs}}</span>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
export default {
  props: ['model', 'onSuccess'],
  mixins: [Permission],
  data: () => ({
    itemInsumos: {},
    table: {
      header: {
        options: [],
        titles: [
          { text: 'IP', value: 'ip', class: 'black--text' },
          { text: 'Version', value: 'version', class: 'black--text' },
          { text: 'Fecha', value: 'fecha', class: 'black--text' },
          { text: 'Comentario', value: 'comentario', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    semana: [
      { name: 'LUNES', nameid: 'lunes' },
      { name: 'MARTES', nameid: 'martes' },
      { name: 'MIERCOLES', nameid: 'miercoles' },
      { name: 'JUEVES', nameid: 'jueves' },
      { name: 'VIERNES', nameid: 'viernes' },
      { name: 'SABADO', nameid: 'sabado' },
      { name: 'DOMINGO', nameid: 'domingo' }
    ],
    value: '',
    events: [],
    colors: ['#2196F3', '#3F51B5', '#673AB7', '#00BCD4', '#4CAF50', '#FF9800', '#757575'],
    names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
    dragEvent: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null
  }),
  components: {},
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapMutations([]),
    successTableAction (item) {
      item.item = this.model
      this.onSuccess(item)
    },
    tableAction (item) {
      this.onSuccess(item)
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    model (val) {}
  }
}
</script>

<style scoped lang="scss">
.v-event-draggable {
  padding-left: 6px;
}
.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}
.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }
  &:hover::after {
    display: block;
  }
}
</style>
